export const UPDATE_CHAT_GPT_PROMPT = 'UPDATE_CHAT_GPT_PROMPT';
export const UPDATE_CHAT_GPT_CUSTOM_PROMPT = 'UPDATE_CHAT_GPT_CUSTOM_PROMPT';
export const UPDATE_CHAT_GPT_RESULT = 'UPDATE_CHAT_GPT_RESULT';
export const START_GPT_REQUEST = 'START_GPT_REQUEST';
export const STOP_GPT_REQUEST = 'STOP_GPT_REQUEST';
export const SET_GPT_ERROR = 'SET_GPT_ERROR';
